import { Prompt } from '../Types/prompt';

const fallbackUserLabel = 'Unknown User';

export const getPromptOwnerName = (prompt: Prompt): string => {
  return prompt.ownerName || prompt.createdByName || fallbackUserLabel;
};
